import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import request from 'superagent';
import { find } from 'lodash';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import ProductManualResult from './ProductManualResult';

class SearchProduct extends Component {
	constructor(props) {
		super(props);

		this.state = {
			products: [],
			options: [],
			selected: null
		};
	}

	handleSearch(query) {
		if (!query) {
			return;
		}
		request.get(`/api/product/search?skuNumber=${query}`)
			.set('authorization', this.props.token)
			.then(resp => JSON.parse(resp.text))
			.then(products => {
				const options = products.map(product => product.modelNumber);
				this.setState({ products, options });
			});
	}

	handleClick(data) {
		this.setState({ selected: data });
		this.setState({ options: [] });
	}

	handleChange(data) {
		const selectedModel = data[0];
		const selected = find(this.state.products, ['modelNumber', selectedModel]);
		this.setState({ selected });
	}

	handleDropdownClick(e) {
		global.dataLayer.push({
			event: 'Support',
			eventCategory: 'Support',
			eventAction: 'Product Manual',
			eventLabel: e.currentTarget.textContent
		});
	}

	render() {
		let selectedProduct;
		let preSearchValue;
		let placeHolder = 'Enter Model Number';
		if (this.state.selected) {
			const selected = this.state.selected;
			selectedProduct = (
				<ProductManualResult data={ selected } />
			);
		}
		
		
		if (
			this.props.product !== null &&
			this.props.product.length > 0 &&
			this.state.options !== null &&
			this.state.options.length < 1 &&
			this.state.selected === null) {
			const preSearchProduct = this.props.product[0];
			placeHolder = preSearchProduct.name;
			preSearchValue = (
				<ProductManualResult data={ preSearchProduct } />
			);
		}

		return (
			<div>
				<AsyncTypeahead
					labelKey="login"
					onSearch={ query => this.handleSearch(query) }
					onChange={ data => this.handleChange(data) }
					options={this.state.options}
					placeholder={ placeHolder }
					filterBy={option => option }
					renderMenuItemChildren={option => (
						<span onClick={ e => this.handleDropdownClick(e) }>
							{ option }
						</span>
					)}
				/>
				{ preSearchValue }
				{ selectedProduct }
			</div>
		);
	}
}

export default branch({
	token: ['token'],
	product: ['product']
}, SearchProduct);


// WEBPACK FOOTER //
// ./src/pages/support/productManuals/SearchProduct.js